export type Benefit = {
    icon: string;
    title: string;
    description: string;
};

export const benefitsText = [
    {
        title: 'Deine Vorteile bei der it-werklerei 💪',
        buttonText: 'Was bietet ihr mir noch? 🙌',
    },
    {
        title: 'Weitere Vorteile bei der it-werklerei 💪',
        buttonText: 'Auf zum letzten Schritt! 🏁',
    },
];

export const benefitsList: Benefit[][] = [
    [
        {
            icon: '🏡',
            title: 'Remote Arbeiten',
            description: 'Uns liegt deine Zufriedenheit und deine persönliche Flexibilität am Herzen.',
        },
        {
            icon: '💰',
            title: 'Faires Gehalt',
            description: 'Uns ist wichtig, dass du für deine Arbeit gerecht bezahlt wirst und deine persönlichen Wünsche erfüllen kannst.',
        },
        {
            icon: '🏖️',
            title: '31 Tage Urlaub',
            description: 'Neben 31 Tagen Urlaub im Jahr bieten wir ein flexibles Arbeitszeitmodell an'
        },
        {
            icon: '🚴‍♂️',
            title: 'Job-Bike',
            description: 'Auf Wunsch erhältst du von uns ein Job-Bike oder ein Job-Ticket'
        }
    ],
    [
        {
            icon: '🎓',
            title: 'Individuelle Weiterbildung',
            description: 'Dir ist ein hohes Maß an Wissen und Bildung im Beruf wichtig? Du legst besonderen Wert auf individuelle Fortbildung? Sehr gerne mit uns!',
        },
        {
            icon: '💻',
            title: 'Beste Ausstattung',
            description: 'Welche Arbeitsausstattung wünschst du dir? Egal ob MacBook oder ThinkPad bei uns bekommst du das, womit du am besten arbeiten kannst.'
        },
        {
            icon: '📇',
            title: 'Moderner Tech-Stack',
            description: 'Arbeite mit den neuesten Technologien und habe Einfluss auf die IT-Welt der Zukunft'
        },
        {
            icon: '😁',
            title: 'Mitbestimmung',
            description: 'Sehr flache Hierarchien, Teamevents und offene Türen'
        },
    ],
];